//changed due to package upgrade
import React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { useLayoutContext } from '@projectK/context/LayoutContextProvider';
import Typography from '@mui/material/Typography';
import FooterWrapper from './FooterWrapper';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import '../AppHeader/custom_styles.sass';
import NearMeIcon from '@mui/icons-material/NearMe';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Capacitor } from '@capacitor/core';
import PropsTypes from 'prop-types';

function stripHtmlTags(html) {
  const tempElement = document.createElement('div');
  tempElement.innerHTML = html;
  return tempElement.textContent || tempElement.innerText || '';
}
const AppFixedFooter = ({ location, companyData, socialSettings }) => {
  const { footer, footerType } = useLayoutContext();
  if (Capacitor.getPlatform() === 'android') {
    return;
  }
  return (
    <>
      <FooterWrapper className='footer'>
        <div className='footer-widgtes'>
          <Container>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 4, md: 3 }}>
                  {companyData?.home_logo_url ? (
                    <img
                      src={`${process.env.NX_CLOUD_FRONT_URL}/${companyData?.home_logo_url}`}
                      alt='comingmatches-img'
                      style={{ width: '200px' }}
                    />
                  ) : (
                    <img
                      src={'/assets/images/membertraxx.png'}
                      alt='comingmatches-img'
                      style={{ width: '200px' }}
                    />
                  )}
                </Grid>
                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                  <h2>About Us</h2>
                  <Typography>
                    {stripHtmlTags(companyData?.store_description || '')}
                  </Typography>
                </Grid>

                <Grid size={{ xs: 12, md: 1 }}></Grid>
                <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                  <h2>Contact Info</h2>
                  <List
                    sx={{ width: '100%', maxWidth: 360, color: 'white' }}
                    aria-label='Products'
                  >
                    {location &&
                      Object.values(location).some((value) => value) && (
                        <ListItem disablePadding>
                          <ListItemButton>
                            <ListItemIcon>
                              <NearMeIcon />
                            </ListItemIcon>
                            <ListItemText>
                              {location.name && `${location.name}, `}
                              {location.address2 && `${location.address2}, `}
                              <br />
                              {location.address1 && `${location.address1}, `}
                              {location.city && `${location.city}, `}
                              <br />
                              {location.state && `${location.state}, `}
                              {location.zip && `${location.zip}.`}
                            </ListItemText>
                          </ListItemButton>
                        </ListItem>
                      )}
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <LocalPhoneIcon />
                        </ListItemIcon>
                        <ListItemText>
                          {companyData?.site_contact_phone_number}
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton>
                        <ListItemIcon>
                          <EmailIcon />
                        </ListItemIcon>
                        <ListItemText>
                          {companyData?.site_contact_email}
                        </ListItemText>
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </div>
        <div className='footerContainer'>
          <Typography>
            &copy; 2024 {companyData?.name}. All Rights Reserved.
          </Typography>
          <Box sx={{ ml: 'auto' }}>
            <Button size='small'>
              <FacebookIcon
                onClick={() => {
                  window.open(socialSettings?.facebook, '_blank');
                }}
              />
            </Button>
            <Button size='small'>
              <XIcon
                onClick={() => {
                  window.open(socialSettings?.twitter, '_blank');
                }}
              />
            </Button>
            <Button
              size='small'
              onClick={() => {
                window.open(socialSettings?.slack, '_blank');
              }}
            >
              <img
                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnElEQVR4nO2VUQrDIBAFPV6l97/A2ntMoQRi1mfdRCmldD4fuwz4TEzppwHuwAMoQO5lM4LCjvWyVQK27MCsINeS5YKO9JqgKk9RqpIbQah4f94CeyMYF39CUAZSCxXql4Cbm6uzZu7z4EoOfMmKeMkiMzUnCJUcvTGKYcmqvBduTnGuZL8dXpwRsLPkd31AZPb170EWxTfZnzTDE1NgIt9EsSxXAAAAAElFTkSuQmCC'
                alt='slack-new'
                style={{ width: '28px' }}
              />
            </Button>
            <Button size='small'>
              <InstagramIcon
                onClick={() => {
                  window.open(socialSettings?.instagram, '_blank');
                }}
              />
            </Button>
          </Box>
        </div>
      </FooterWrapper>

      {footer && footerType === 'inherit' ? (
        <FooterWrapper className='footer '>
          <div className='footer-widgtes'>
            <Typography>Copy right @crema 2021</Typography>
            <Box sx={{ ml: 'auto' }}>
              <Button color='primary'>Buy Now</Button>
            </Box>
          </div>
        </FooterWrapper>
      ) : null}
    </>
  );
};
AppFixedFooter.propTypes = {
  location: PropsTypes.object,
  socialSettings: PropsTypes.object,
  companyData: PropsTypes.object,
};
export default AppFixedFooter;
